// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".quick-action-button button[data-v-c2c6edb2] {\n  outline: 0;\n}\n.quick-action-button .icon[data-v-c2c6edb2] {\n  font-size: 12px;\n  fill: #fff;\n  display: block;\n}\n", ""]);
// Exports
module.exports = exports;
